import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 1fr minmax(auto, 600px);
	gap: 40px;
	height: 100%;
	padding: 0 40px;
	transition: opacity 0.3s ease;

	@media (max-width: 1500px) {
		gap: 20px;
	}

	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}
`;

const StyledLeftContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows: 240px 240px 238px 120px;
	gap: 20px;
	padding: 20px 0;
`;

export { StyledContainer, StyledLeftContainer };
